import React, { Suspense, ComponentType, LazyExoticComponent } from "react";
import Loader from "components/Loader/Loader";

export function lazyLoad<T extends ComponentType<any>>(
  importFn: () => Promise<{ default: T }>
): LazyExoticComponent<T> {
  return React.lazy(importFn);
}

export const LazyBoundary: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <Suspense fallback={<Loader />}>{children}</Suspense>;

export function prefetchRoute(importFn: () => Promise<unknown>): void {
  const run = () => importFn().catch(() => { /* ignore prefetch failures silently */ });

  if (typeof window === "undefined") return;

  if ("requestIdleCallback" in window) {
    (
      window as Window &
        typeof globalThis & {
          requestIdleCallback: (cb: () => void) => void;
        }
    ).requestIdleCallback(run);
  } else {
    // Fallback for Safari and older browsers
    setTimeout(run, 200);
  }
}
